module.exports = __webpack_public_path__ + "img/GAME_THREE1.b72b9f6c.jpg";